import {cn} from '~/design-system/utils'
import HgIcon from '../../HgIcon'
import {type HgTableIconCell} from '../types'

const IconCell = ({iconType, className}: HgTableIconCell) => {
  return (
    <div className={cn('flex h-full w-full items-center', className)}>
      <HgIcon size="large" iconType={iconType} className="text-icon-default" />
    </div>
  )
}

export default IconCell
